import api from './api';
const emailInbox = {
  context: id => api.get(`/email-inbox/conversations/${id}/context`),
  saveContext: (id, data) => api.post(`/email-inbox/conversations/${id}/context`, data),
  connection: () => api.get('/email-inbox/connection'),
  connect: data => api.post('/email-inbox/connection', data, { timeout: 60000 }),
  disconnect: () => api.delete('/email-inbox/connection'),
  sync: () => api.post('/email-inbox/sync', {}, { timeout: 120000 }),
  conversations: params => api.get('/email-inbox/conversations', { params }),
  messages: (id, params) => api.get(`/email-inbox/conversations/${id}/messages`, { params }),
  body: id => api.get(`/email-inbox/messages/${id}/body`, { timeout: 60000 }),
  update: (id, status) => api.patch(`/email-inbox/conversations/${id}`, { status }),
  reply: (id, data) => api.post(`/email-inbox/conversations/${id}/replies`, data, { timeout: 60000 }),
};
export default emailInbox;
